import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/img/icon/dashboard-outline-darkgreen.png'
import _imports_1 from '@/assets/img/default-profile.png'
import _imports_2 from '@/assets/img/icon/red-card-fill.png'
import _imports_3 from '@/assets/img/icon/yellow-card-fill.png'


const _hoisted_1 = { class: "md:grid grid-cols-2 gap-4 mt-4" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "invalid-feedback" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = { class: "invalid-feedback" }
const _hoisted_6 = {
  key: 0,
  class: "my-4"
}
const _hoisted_7 = { class: "rounded-xl background-grey-2 px-6 py-4" }
const _hoisted_8 = { class: "md:flex items-center gap-3 justify-between" }
const _hoisted_9 = { class: "flex items-center gap-3" }
const _hoisted_10 = { class: "text-base font-bold" }
const _hoisted_11 = { class: "text-grey-5" }
const _hoisted_12 = { class: "flex items-center gap-3 justify-end" }
const _hoisted_13 = { class: "flex items-center gap-3" }
const _hoisted_14 = { class: "text-red font-bold" }
const _hoisted_15 = { class: "flex items-center gap-3" }
const _hoisted_16 = { class: "text-orange-1 font-bold" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "mb-4" }
const _hoisted_19 = { class: "invalid-feedback" }
const _hoisted_20 = { class: "grid md:grid-cols-2 gap-4 mb-4" }
const _hoisted_21 = { class: "invalid-feedback" }
const _hoisted_22 = { class: "invalid-feedback" }
const _hoisted_23 = { class: "mb-4" }
const _hoisted_24 = { class: "invalid-feedback" }
const _hoisted_25 = { class: "mb-4" }
const _hoisted_26 = {
  for: "description",
  class: "label-text required"
}
const _hoisted_27 = { class: "invalid-feedback" }
const _hoisted_28 = { class: "flex h-full flex-col background-grey-3 rounded-xl p-4" }
const _hoisted_29 = { class: "flex flex-1 flex-col" }
const _hoisted_30 = { class: "flex flex-1 flex-col items-center justify-center background-white rounded-xl p-4" }
const _hoisted_31 = {
  key: 0,
  class: "text-center"
}
const _hoisted_32 = ["src"]
const _hoisted_33 = ["src"]
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "flex mt-40px justify-end" }

import { useRoute, useRouter } from 'vue-router'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Dropdown from 'primevue/dropdown'
import Textarea from 'primevue/textarea'
import * as Yup from 'yup'
import { useStore } from 'vuex'
import InputSwitch from 'primevue/inputswitch'
import { onMounted, getCurrentInstance, ref, computed, watch, reactive } from 'vue'
import apiUseCase from '@/usecase/apiUseCase'
import rgxExp from '@/utils/helpers/regExp'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import { useForm, Field } from 'vee-validate'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import Card from 'primevue/card'
import Calendar from 'primevue/calendar'
import SelectAsync from '@/views/components/form/SelectAsync.vue'
import ButtonFileUpload from '@/views/components/button/FileUpload.vue'
import { getDynamicStatusBg, getDynamicStatusColor } from '@/utils/helpers/colorStatusLabel'
import apiAkdpUseCase from '@/usecase/apiAkdpUseCase'
import moment from 'moment'
import HjpConfirmationModal from '@/views/components/modal/HjpConfirmationModal.vue'
import environment from '@/configs/environtment'
import SelectAsyncTransactionPpOptions from '@/views/components/form/SelectAsyncTransactionPpOptions.vue'
import apiImageUseCase from '@/usecase/apiImageUseCase'
import numberFormat from '@/utils/helpers/numberFormat'
import cardLabelList from './cardLabelList'
import EmployeeViolationHistory from './components/EmployeeViolationHistory.vue'

const employeePenaltyEndpoint = 'talent/v1/employeePenalties'
const employeeEndpoint = 'talent/v1/employees'
const maxSizeFile = 1024 * 1024 * 2 // 2MB

export default /*@__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const store = useStore()
const idPrams = ref()
const isLoading = ref(true)
const isSubmitInProgress = ref(false)
const employeePenaltyAttributeIds = ref<Record<string, string | number | null>>({})
const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties
const tempImgProfile = ref<any | null>(null)
const isShowViolenceHistory = ref(false)
const selectedViolenceHistory = ref<number[]>([])
const employeeViolenceHistory = ref<any>([])
const afterPostPenaltyId = ref<any | null>(null)
const employeePenaltySummary = ref([]) as any
const employeeDetail = ref(null) as any
const maxAccidentDate = new Date()

const getPenaltySummaryCount = (penaltyTypeName: string) => {
  const summaries = employeePenaltySummary.value
  if (!Array.isArray(summaries) || summaries.length === 0) {
    return 0
  }

  const summary = summaries.find((item: any) => (
    (item.penaltyTypeName ?? item.PenaltyTypeName)?.toLowerCase() === penaltyTypeName.toLowerCase()
  ))
  if (!summary) {
    return 0
  }

  return numberFormat(Number(summary.count ?? summary.Count ?? 0))
}

const schema = Yup.object({
  CardType: Yup.object().required('Jenis Pelanggaran harus diisi'),
  Employee: Yup.object().required('Nama Karyawan harus diisi'),
  Description: Yup.string()
    .required('Catatan Pelanggaran harus diisi')
    .min(3, 'Catatan Pelanggaran tidak boleh kurang dari 3 karakter')
    .max(300, 'Catatan Pelanggaran tidak boleh lebih dari 300 karakter'),
  EvidenceImage: Yup.object().notRequired(),
  AccidentDate: Yup.date().nullable().when('CardType', {
    is: (cardType: any) => cardType?.name === 'Kartu Merah',
    then: (field) => field
      .required('Tanggal Kejadian harus diisi')
      .test(
        'not-in-future',
        'Tanggal Kejadian tidak boleh lebih dari waktu saat ini',
        (value) => !value || moment(value).isSameOrBefore(moment())
      ),
    otherwise: (field) => field.notRequired()
  }),
  ActionDate: Yup.date().nullable().when('CardType', {
    is: (cardType: any) => cardType?.name === 'Kartu Merah',
    then: (field) => field
      .required('Tanggal Tindakan harus diisi')
      .test(
        'not-before-accident',
        'Tanggal Tindakan tidak boleh kurang dari Tanggal Kejadian',
        function validateActionDate(value) {
          const accidentDate = this.parent.AccidentDate
          return !value || (
            !!accidentDate && moment(value).isSameOrAfter(moment(accidentDate), 'day')
          )
        }
      ),
    otherwise: (field) => field.notRequired()
  }),
  Location: Yup.string().nullable().when('CardType', {
    is: (cardType: any) => cardType?.name === 'Kartu Merah',
    then: (field) => field
      .required('Lokasi Kejadian harus diisi')
      .min(3, 'Lokasi Kejadian tidak boleh kurang dari 3 karakter')
      .max(100, 'Lokasi Kejadian tidak boleh lebih dari 100 karakter'),
    otherwise: (field) => field.notRequired()
  }),
  PPAccident: Yup.object().nullable().when('CardType', {
    is: (cardType: any) => cardType?.name === 'Kartu Merah',
    then: (field) => field.notRequired(),
    otherwise: (field) => field.notRequired()
  })
})

const { values, errors, setFieldValue, handleSubmit, resetForm, meta } = useForm({
  validationSchema: schema,
  initialValues: {
    CardType: null as any,
    Employee: null as any,
    Description: '',
    EvidenceImage: null as any,
    AccidentDate: null as any,
    ActionDate: null as any,
    Location: null as any,
    PPAccident: null as any,
  }
})

const initialFormSnapshot = ref<any>(null)

const getFormSnapshot = (formValues: any) => {
  const dateValue = (value: any) => (
    value && moment(value).isValid() ? moment(value).valueOf() : null
  )

  return {
    employeeId: formValues.Employee?.id ?? formValues.Employee?.Id ?? null,
    cardTypeId: formValues.CardType?.id ?? formValues.CardType?.Id ?? null,
    incidentDate: dateValue(formValues.AccidentDate),
    evidenceUrl: formValues.EvidenceImage?.blob ?? null,
    evidenceFile: formValues.EvidenceImage?.file ?? null,
    description: formValues.Description ?? '',
    actionDate: dateValue(formValues.ActionDate),
    location: formValues.Location ?? null,
    ppAccidentId: formValues.PPAccident?.dataParent?.Id
      ?? formValues.PPAccident?.value
      ?? formValues.PPAccident?.Id
      ?? formValues.PPAccident?.id
      ?? null
  }
}

const isRedCard = computed(() => values.CardType?.name === 'Kartu Merah')

watch(() => values.CardType, (cardType, previousCardType) => {
  if (previousCardType && cardType !== previousCardType) {
    setFieldValue('ActionDate', null, false)
    setFieldValue('AccidentDate', null, false)
    setFieldValue('Location', null, false)
    setFieldValue('PPAccident', null, false)
  }
})

watch(() => values.AccidentDate, (accidentDate) => {
  const actionDate = values.ActionDate
  if (!accidentDate || (
    actionDate && moment(actionDate).isBefore(moment(accidentDate), 'day')
  )) {
    setFieldValue('ActionDate', null, false)
  }
})

const attrModalConfirmation = reactive({
  show: false,
  title: 'Kartu Pelanggaran Berhasil Disimpan',
  subTitle: '',
  btnSubmitTitle: 'Input Denda',
  btnBackTitle: 'Nanti Saja',
  subTitleHtml: true,
  imgContent: require('@/assets/img/modal-confirmation/check-circle-fill-darkgreen.png')
})

const getTransactionPpData = async (ppId: string | number) => {
  try {
    const { error, result, message } = await apiAkdpUseCase.get(`transaction/v2/TransactionPps?q=${ppId}`)
    if (error) {
      $toast.add({
        severity: 'error',
        summary: 'Gagal memuat data PP',
        detail: message,
        life: 3000
      })
      return null
    }
    return result[0] ?? null
  } catch (error) {
    $toast.add({
      severity: 'error',
      summary: 'Gagal memuat data PP',
      detail: error,
      life: 3000
    })
    return null
  }
}

const getData = async () => {
  store.dispatch('showLoading')
  try {
    const response = await apiUseCase.get(`${employeePenaltyEndpoint}/${idPrams.value}`)
    const { error, result } = response
    if (!error) {
      const attributes = Array.isArray(result.attributes) ? result.attributes : []
      const getAttributeValue = (key: string) => {
        const attribute = attributes.find(
          (item: any) => (item.key ?? item.Key)?.toLowerCase() === key.toLowerCase()
        )
        return attribute?.value ?? attribute?.Value
      }
      const employeePenaltyAttributes = Array.isArray(result.employeePenaltyAttributes)
        ? result.employeePenaltyAttributes
        : []
      const getEmployeePenaltyAttribute = (key: string) => employeePenaltyAttributes.find(
        (item: any) => (item.key ?? item.Key)?.toLowerCase() === key.toLowerCase()
      )
      const getEmployeePenaltyAttributeValue = (key: string) => {
        const attribute = getEmployeePenaltyAttribute(key)
        return attribute?.value ?? attribute?.Value
      }
      const getEmployeePenaltyAttributeId = (...keys: string[]) => keys
        .map((key) => getEmployeePenaltyAttribute(key) ?? attributes.find(
            (item: any) => (item.key ?? item.Key)?.toLowerCase() === key.toLowerCase()
          ))
        .map((attribute: any) => (
          attribute?.id ?? attribute?.Id ?? attribute?.attributeId ?? attribute?.AttributeId ?? null
        ))
        .find((attributeId) => attributeId != null) ?? null
      employeePenaltyAttributeIds.value = {
        DisciplinaryDate: getEmployeePenaltyAttributeId('DisciplinaryDate', 'DisiplinaryDate'),
        Location: getEmployeePenaltyAttributeId('Location'),
        BusSchedule: getEmployeePenaltyAttributeId('BusSchedule')
      }
      const cardTypeData = result.penaltyType || {}
      const cardTypeId = cardTypeData.id ?? cardTypeData.Id ?? result.penaltyTypeId
      let cardTypeName = cardTypeData.name ?? cardTypeData.Name ?? result.penaltyTypeName
      if (!cardTypeName && result.penaltyTypeCode) {
        cardTypeName = result.penaltyTypeCode === 'YLW' ? 'Kartu Kuning' : 'Kartu Merah'
      }
      cardTypeName = cardTypeName ?? ''
      const employeeData = result.employee || {}
      const employeeId = employeeData.id ?? employeeData.Id ?? result.employeeId
      const employeeFullName = employeeData.fullName ?? employeeData.FullName ?? result.employeeFullName
      const ppAccidentData = result.ppAccident
        ?? result.busSchedule
        ?? getEmployeePenaltyAttributeValue('BusSchedule')
        ?? getAttributeValue('BusSchedule')
      const ppAccidentOption = ppAccidentData && typeof ppAccidentData === 'object'
        ? ppAccidentData
        : {}
      const ppAccidentParent = ppAccidentOption.dataParent ?? ppAccidentOption
      const ppAccidentId = ppAccidentOption.value
        ?? ppAccidentParent.Id
        ?? ppAccidentParent.id
        ?? ppAccidentParent.TransactionPpId
        ?? ppAccidentParent.TransactionPp?.Id
        ?? ppAccidentParent.TransactionPp?.id
        ?? (typeof ppAccidentData === 'object' ? null : ppAccidentData)
      const transactionPpData = ppAccidentId != null
        ? await getTransactionPpData(ppAccidentId)
        : null
      const actionDate = getEmployeePenaltyAttributeValue('DisciplinaryDate')
        ?? getEmployeePenaltyAttributeValue('DisiplinaryDate')
        ?? result.actionDate
        ?? result.disciplinaryDate
        ?? getAttributeValue('DisciplinaryDate')
        ?? getAttributeValue('DisiplinaryDate')
      const parsedActionDate = typeof actionDate === 'string'
        ? moment(actionDate, [
          moment.ISO_8601,
          'DD MMMM YYYY HH:mm',
          'DD MMMM YYYY',
          'DD-MM-YYYY',
          'DD/MM/YYYY'
        ], true)
        : moment(actionDate)
      let ppAccident = null as any
      if (ppAccidentId != null) {
        const transactionPpParent = transactionPpData?.dataParent ?? transactionPpData ?? ppAccidentParent
        const transactionPp = transactionPpParent.TransactionPp ?? {}
        const trxId = transactionPp.TrxId
          ?? transactionPpParent.TrxId
          ?? ppAccidentOption.label?.TrxId
          ?? result.busScheduleName
          ?? ''
        const conductorName = transactionPp.CondecturName
          ?? transactionPpParent.CondecturName
          ?? ''
        const vehicleRegNumber = transactionPp.VehicleRegNumber
          ?? transactionPpParent.VehicleRegNumber
          ?? ''
        const departureTime = transactionPp.DepartureTime
          ?? transactionPpParent.DepartureTime
          ?? ''
        const ritOrder = transactionPpParent.RitOrder ?? ''
        const searchLabel = ppAccidentOption.searchLabel
          ?? [trxId, conductorName, vehicleRegNumber, departureTime, ritOrder]
            .filter(Boolean)
            .join(' ')

        ppAccident = {
          ...ppAccidentOption,
          dataParent: {
            ...transactionPpParent,
            Id: transactionPpParent.Id ?? transactionPpParent.id ?? ppAccidentId,
            TransactionPp: {
              ...transactionPp,
              TrxId: trxId,
              CondecturName: conductorName,
              VehicleRegNumber: vehicleRegNumber,
              DepartureTime: departureTime
            },
            RitOrder: ritOrder
          },
          label: {
            TrxId: trxId,
            CondecturName: conductorName,
            VehicleRegNumber: vehicleRegNumber,
            DepartureTime: departureTime,
            RitOrder: ritOrder
          },
          searchLabel,
          value: ppAccidentId
        }
      }
      const evidenceUrl = result.evidenceUrl ?? null

      const formValues = {
        CardType: cardTypeId != null
          ? { ...cardTypeData, id: cardTypeId, name: cardTypeName, value: cardTypeId, label: cardTypeName }
          : null,
        Employee: employeeId != null
          ? { ...employeeData, id: employeeId, fullName: employeeFullName, value: employeeId, label: employeeFullName }
          : null,
        Description: result.description ?? '',
        EvidenceImage: evidenceUrl ? { blob: evidenceUrl } : null,
        AccidentDate: result.incidentDate ? new Date(result.incidentDate) : null,
        ActionDate: actionDate && parsedActionDate.isValid() ? parsedActionDate.toDate() : null,
        Location: getEmployeePenaltyAttributeValue('Location')
          ?? result.location
          ?? getAttributeValue('Location')
          ?? null,
        PPAccident: ppAccident
      }
      resetForm({ values: formValues })
      initialFormSnapshot.value = getFormSnapshot(formValues)
    }
  } finally {
    store.dispatch('hideLoading')
    isLoading.value = false
  }
}

const onInputFile = (file: any, typeUpload: string) => {
  /* eslint-disable */
  if (file) {
    const totalSize: number = Number((file.size / 1024 / 1024).toFixed(1))
    if (totalSize > 2) {
      $toast.add({
        severity: 'error',
        summary: 'Gagal Upload',
        detail: 'Ukuran file melebihi 2MB',
        life: 3000
      })
    } else if (!rgxExp.imageFile.test(file.name)) {
      $toast.add({
        severity: 'error',
        summary: 'Gagal Upload',
        detail: 'Format file tidak sesuai (JPG, PNG, JPEG)',
        life: 3000
      })
    } else {
      /* eslint-disable-next-line */
      if (file) {
        if (typeUpload === 'photo-profile') {
          // tempImgProfile.value = file.blob
          setFieldValue('EvidenceImage', { file: file.file, name: file.name, blob: file.blob })
        }
      }
    }
  }
}

const openDetailImg = (fileUrl: string) => {
  window.open(fileUrl, '_blank')
}

const showViolenceHistory = () => {
  isShowViolenceHistory.value = !isShowViolenceHistory.value
  selectedViolenceHistory.value = []
}

const toggleViolenceHistory = (id: number) => {
  const selectedIndex = selectedViolenceHistory.value.indexOf(id)
  if (selectedIndex === -1) {
    selectedViolenceHistory.value.push(id)
  } else {
    selectedViolenceHistory.value.splice(selectedIndex, 1)
  }
}

const onBack = () => {
  const previousRoute = router.options.history.state.back
  if (previousRoute && router.resolve(previousRoute).name === 'violation-card-detail') {
    router.back()
    return
  }

  router.push({
    name: 'violation-card'
  })
}

const hideDialogConfirmation = () => {
  attrModalConfirmation.show = false
  onBack()
}

const toDetailPage = () => {
  const encryptPenaltyId = encryptDecriptMethods.encrypt(afterPostPenaltyId.value)
  router.push({
    name: 'violation-card-detail',
    params: { id: encryptPenaltyId }
  })
}

const getEmployeePenaltiesSummaryAct = async (employeeId: string) => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${employeeEndpoint}/${employeeId}/penalties/summary`).then((response) => {
    const { error, result } = response
    if (!error) {
      employeePenaltySummary.value = result
    }
  })
  store.dispatch('hideLoading')
}

const getEmployeeDetailAct = async (employeeId: string) => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${employeeEndpoint}/${employeeId}`).then((response) => {
    const { error, result } = response
    if (!error) {
      employeeDetail.value = result
      if (
        idPrams.value
        && values.Employee?.id === employeeId
        && values.Employee.authUserId !== result.authUserId
      ) {
        setFieldValue('Employee', {
          ...values.Employee,
          authUserId: result.authUserId
        }, false)
      }
    }
  })
  store.dispatch('hideLoading')
}

const processSubmitPenaltyAttributes = async (
  penaltyId: string | number,
  payload: { key: string; value: any },
  attributeId: string | number | null
) => {
  try {
    const isNewAttribute = attributeId == null
    const requestPayload = isNewAttribute
      ? payload
      : { id: attributeId, ...payload }
    const { error, message, result } = await apiUseCase.postOrPut(
      `${employeePenaltyEndpoint}/${penaltyId}/attributes`,
      attributeId,
      requestPayload
    )
    if (error) {
      $toast.add({
        severity: 'error',
        summary: 'Atribut Kartu gagal disimpan',
        detail: message,
        life: 3000
      })
      return false
    }
    if (isNewAttribute) {
      employeePenaltyAttributeIds.value[payload.key] = result?.id ?? result?.Id ?? null
    }
    return true
  } catch (error) {
    $toast.add({
      severity: 'error',
      summary: 'Atribut Kartu gagal disimpan',
      detail: error,
      life: 3000
    })
    return false
  }
}

const processUpload: string | null | any = async (file: any) => {
  const payload = new FormData()
  payload.append('file', file)
  payload.append('SpecialPath', 'violation')
  console.log('payload', payload)
  const response = await apiImageUseCase.postOrPut('api/v1/assets', null, payload)
  console.log('response', response)
  if (!response.error) {
    return response.result.path
  } else if (response.code === 401) {
    // refresh token & hit again
    store.dispatch('refreshToken')
    return
  }
  return null
}


const onSubmit = handleSubmit(async (dataForm: any) => {
  if (isSubmitInProgress.value) {
    return
  }
  isSubmitInProgress.value = true
  store.dispatch('showLoading')
  try {
    const snapshot = getFormSnapshot(dataForm)
    const baseline = initialFormSnapshot.value
    const isNewRecord = !idPrams.value
    const hasMainChanges = isNewRecord
      || !baseline
      || baseline.employeeId !== snapshot.employeeId
      || baseline.cardTypeId !== snapshot.cardTypeId
      || baseline.incidentDate !== snapshot.incidentDate
      || baseline.evidenceUrl !== snapshot.evidenceUrl
      || baseline.evidenceFile !== snapshot.evidenceFile
      || baseline.description !== snapshot.description
    const hasActionDateChanged = isNewRecord
      ? dataForm.ActionDate != null
      : !baseline || baseline.actionDate !== snapshot.actionDate
    const hasLocationChanged = isNewRecord
      ? dataForm.Location != null
      : !baseline || baseline.location !== snapshot.location
    const hasPPAccidentChanged = isNewRecord
      ? dataForm.PPAccident != null
      : !baseline || baseline.ppAccidentId !== snapshot.ppAccidentId
    const hasAnyChanges = hasMainChanges
      || hasActionDateChanged
      || hasLocationChanged
      || hasPPAccidentChanged

    if (!hasAnyChanges) {
      $toast.add({
        severity: 'success',
        summary: 'Kartu pelanggaran berhasil disimpan',
        detail: 'Tidak ada perubahan pada data kartu pelanggaran',
        group: 'bc',
        life: 3000
      })
      onBack()
      return
    }

    let penaltyId = idPrams.value
    let saveSucceeded = true
    let savedEvidenceUrl = dataForm.EvidenceImage?.blob ?? null

    if (hasMainChanges) {
      const imageTemp = dataForm.EvidenceImage?.file
        ? await processUpload(dataForm.EvidenceImage.file)
        : null
      const payload = {
        employeeId: dataForm.Employee.id,
        penaltyTypeId: dataForm.CardType.id,
        incidentDate: dataForm.AccidentDate
          ? moment(dataForm.AccidentDate).format('YYYY-MM-DDTHH:mm:ssZ')
          : moment().format('YYYY-MM-DDTHH:mm:ssZ'),
        evidenceUrl: imageTemp
          ? `${environment.getApiBaseImageUrl()}${imageTemp}`
          : dataForm.EvidenceImage?.blob ?? null,
        description: dataForm.Description
      }

      const response = await apiUseCase.postOrPut(
        `${employeePenaltyEndpoint}`,
        idPrams.value,
        idPrams.value ? { ...payload, id: idPrams.value } : payload
      )
      if (response.error) {
        saveSucceeded = false
        $toast.add({
          severity: 'error',
          summary: `Kartu gagal ${idPrams.value ? 'diubah' : 'ditambahkan'}!`,
          detail: response.message,
          life: 3000
        })
      } else {
        penaltyId = response.result?.id ?? idPrams.value
        savedEvidenceUrl = payload.evidenceUrl
      }
    }

    if (saveSucceeded && penaltyId != null) {
      const attributeRequests = []
      if (hasActionDateChanged) {
        attributeRequests.push(processSubmitPenaltyAttributes(penaltyId, {
          key: 'DisciplinaryDate',
          value: dataForm.ActionDate
            ? moment(dataForm.ActionDate).format('DD MMMM YYYY HH:mm')
            : null
        }, employeePenaltyAttributeIds.value.DisciplinaryDate))
      }
      if (hasLocationChanged) {
        attributeRequests.push(processSubmitPenaltyAttributes(penaltyId, {
          key: 'Location',
          value: dataForm.Location
        }, employeePenaltyAttributeIds.value.Location))
      }
      if (hasPPAccidentChanged) {
        attributeRequests.push(processSubmitPenaltyAttributes(penaltyId, {
          key: 'BusSchedule',
          value: dataForm.PPAccident?.dataParent?.TransactionPp?.TrxId
            ?? dataForm.PPAccident?.dataParent?.TrxId
            ?? dataForm.PPAccident?.label?.TrxId
            ?? dataForm.PPAccident?.TrxId
            ?? null
        }, employeePenaltyAttributeIds.value.BusSchedule))
      }
      const attributeResults = await Promise.all(attributeRequests)
      saveSucceeded = attributeResults.every(Boolean)
    }

    if (saveSucceeded && hasAnyChanges) {
      $toast.add({
        severity: 'success',
        summary: `Kartu berhasil ${isNewRecord ? 'ditambahkan' : 'diubah'}!`,
        detail: `Data kartu pelanggaran berhasil ${isNewRecord ? 'ditambahkan' : 'diubah'}`,
        group: 'bc',
        life: 3000
      })

      const savedValues = {
        ...dataForm,
        EvidenceImage: savedEvidenceUrl ? { blob: savedEvidenceUrl } : null
      }
      // resetForm({ values: savedValues })
      initialFormSnapshot.value = getFormSnapshot(savedValues)

      if (isNewRecord) {
        afterPostPenaltyId.value = penaltyId
        attrModalConfirmation.subTitle = `Kartu pelanggaran <b>${dataForm.Employee.fullName}</b> berhasil disimpan. Apakah Anda ingin lanjut input denda?`
        attrModalConfirmation.show = true
      }
    }
  } catch (error) {
    $toast.add({
      severity: 'error',
      summary: `Kartu gagal ${idPrams.value ? 'diubah' : 'ditambahkan'}!`,
      detail: error,
      life: 3000
    })
  } finally {
    store.dispatch('hideLoading')
    isSubmitInProgress.value = false
  }
})

watch(() => values.Employee?.id, (employeeId) => {
  if (employeeId) {
    getEmployeePenaltiesSummaryAct(employeeId)
    getEmployeeDetailAct(employeeId)
  } else {
    employeePenaltySummary.value = []
  }
})

onMounted(() => {
  if (route.params.id) {
    idPrams.value = encryptDecriptMethods.decrypt(route.params.id)
    getData()
  } else {
    isLoading.value = false
  }
  store.dispatch('ui/setBreadcrumbs', [
    {
      title: 'Kartu Pelanggaran',
      routeName: 'violation-card'
    },
    {
      title: `${route.params.id ? 'Edit' : 'Tambah'} Kartu Pelanggaran`,
      routeName: 'violation-card-form'
    },
  ])
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)), ["prevent"]))
        }, [
          _createVNode(_unref(Card), { class: "card-no-shadow wrap-hjp-data-table" }, {
            content: _withCtx(() => [
              _cache[34] || (_cache[34] = _createElementVNode("div", { class: "flex items-center gap-2" }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "X"
                }),
                _createElementVNode("div", { class: "text-xl font-bold" }, "Informasi Pelanggaran")
              ], -1)),
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_2, [
                    _cache[16] || (_cache[16] = _createElementVNode("label", {
                      for: "cardType",
                      class: "label-text required"
                    }, "Jenis Pelanggaran", -1)),
                    _createVNode(_unref(Field), {
                      id: "cardType",
                      name: "CardType",
                      class: _normalizeClass(`input-primary ${_unref(errors).CardType ? 'input-invalid' : ''}`),
                      validateOnInput: true
                    }, {
                      default: _withCtx(() => [
                        _createVNode(SelectAsync, {
                          placeholder: 'Pilih Jenis Pelanggaran',
                          modelValue: _unref(values).CardType,
                          "onUpdate:modelValue": [
                            _cache[0] || (_cache[0] = ($event: any) => ((_unref(values).CardType) = $event)),
                            _cache[1] || (_cache[1] = (val) => _unref(setFieldValue)('CardType', val))
                          ],
                          id: 'cardType',
                          inputId: 'cardType',
                          endpoint: "/talent/v1/penaltyTypes",
                          classname: 'custom-select',
                          disabled: false,
                          fieldLabel: (v) => `${v.name}`,
                          clearable: false,
                          searchFields: ['name']
                        }, null, 8, ["modelValue", "fieldLabel"])
                      ]),
                      _: 1
                    }, 8, ["class"]),
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(errors).CardType), 1)
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _cache[22] || (_cache[22] = _createElementVNode("label", {
                      for: "employee",
                      class: "label-text required"
                    }, "Nama Karyawan", -1)),
                    _createVNode(_unref(Field), {
                      id: "employee",
                      name: "Employee",
                      class: _normalizeClass(`input-primary ${_unref(errors).Employee ? 'input-invalid' : ''}`),
                      validateOnInput: true
                    }, {
                      default: _withCtx(() => [
                        _createVNode(SelectAsync, {
                          placeholder: 'Pilih Nama Karyawan',
                          modelValue: _unref(values).Employee,
                          "onUpdate:modelValue": [
                            _cache[2] || (_cache[2] = ($event: any) => ((_unref(values).Employee) = $event)),
                            _cache[3] || (_cache[3] = (val) => _unref(setFieldValue)('Employee', val))
                          ],
                          id: 'employee',
                          inputId: 'employee',
                          endpoint: "/talent/v1/employees",
                          classname: 'custom-select',
                          disabled: false,
                          fieldLabel: (v) => `${v.fullName}`,
                          clearable: false,
                          searchFields: ['fullName']
                        }, null, 8, ["modelValue", "fieldLabel"])
                      ]),
                      _: 1
                    }, 8, ["class"]),
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(errors).Employee), 1),
                    (_unref(values).Employee)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("div", _hoisted_9, [
                                _cache[17] || (_cache[17] = _createElementVNode("img", {
                                  src: _imports_1,
                                  width: "50",
                                  class: "rounded-full",
                                  alt: "photo"
                                }, null, -1)),
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_10, _toDisplayString(employeeDetail.value?.fullName ?? '-'), 1),
                                  _createElementVNode("div", _hoisted_11, _toDisplayString(`${employeeDetail.value?.employments[employeeDetail.value?.employments.length - 1].positionName ?? '-'} | ${employeeDetail.value?.personnelNumber ?? '-'}`), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("div", _hoisted_14, _toDisplayString(getPenaltySummaryCount('Kartu Merah')), 1),
                                    _cache[18] || (_cache[18] = _createElementVNode("img", {
                                      src: _imports_2,
                                      alt: "merah"
                                    }, null, -1))
                                  ]),
                                  _cache[19] || (_cache[19] = _createElementVNode("div", { class: "text-grey-5" }, "Kartu Merah", -1))
                                ]),
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, _toDisplayString(getPenaltySummaryCount('Kartu Kuning')), 1),
                                    _cache[20] || (_cache[20] = _createElementVNode("img", {
                                      src: _imports_3,
                                      alt: "kuning"
                                    }, null, -1))
                                  ]),
                                  _cache[21] || (_cache[21] = _createElementVNode("div", { class: "text-grey-5" }, "Kartu Kuning", -1))
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", {
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (showViolenceHistory())),
                            class: "text-primary text-base font-bold underline cursor-pointer w-fit"
                          }, "Lihat Riwayat Pelanggaran")
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _cache[26] || (_cache[26] = _createElementVNode("div", { class: "text-lg font-bold" }, "Detail Pelanggaran", -1)),
                  (_unref(values).CardType?.name === 'Kartu Merah')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _cache[23] || (_cache[23] = _createElementVNode("label", {
                            for: "ppAccident",
                            class: _normalizeClass(['label-text'])
                          }, "PP Kejadian", -1)),
                          _createVNode(_unref(Field), {
                            id: "ppAccident",
                            name: "PPAccident",
                            class: _normalizeClass(`input-primary ${_unref(errors).PPAccident ? 'input-invalid' : ''}`)
                          }, {
                            default: _withCtx(() => [
                              _createVNode(SelectAsyncTransactionPpOptions, {
                                endpoint: `transaction/v2/TransactionPps`,
                                classname: "custom-select",
                                fieldLabel: (v) => v.TrxId,
                                searchFields: ['q'],
                                searchCustom: [['crewId', '=', _unref(values).Employee?.authUserId]],
                                placeholder: 'Pilih PP',
                                modelValue: _unref(values).PPAccident,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = (val) => _unref(setFieldValue)('PPAccident', val)),
                                disabled: !_unref(values).Employee,
                                inputId: "ppAccident"
                              }, null, 8, ["fieldLabel", "searchCustom", "modelValue", "disabled"])
                            ]),
                            _: 1
                          }, 8, ["class"]),
                          _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(errors).PPAccident), 1)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", null, [
                            _cache[24] || (_cache[24] = _createElementVNode("label", {
                              for: "accidentDate",
                              class: "label-text required"
                            }, "Tanggal Kejadian", -1)),
                            _createVNode(_unref(Field), { name: "AccidentDate" }, {
                              default: _withCtx(({ handleChange }) => [
                                _createVNode(_unref(Calendar), {
                                  inputId: "accidentDate",
                                  modelValue: _unref(values).AccidentDate,
                                  "onUpdate:modelValue": [
                                    _cache[6] || (_cache[6] = ($event: any) => ((_unref(values).AccidentDate) = $event)),
                                    handleChange
                                  ],
                                  maxDate: _unref(maxAccidentDate),
                                  dateFormat: "dd/mm/yy",
                                  showTime: "",
                                  hourFormat: "24",
                                  placeholder: "DD/MM/YYYY HH:mm",
                                  class: "w-full",
                                  manualInput: false,
                                  inputClass: `${_unref(errors).AccidentDate ? 'input-invalid' : ''}`
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "maxDate", "inputClass"])
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(errors).AccidentDate), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _cache[25] || (_cache[25] = _createElementVNode("label", {
                              for: "actionDate",
                              class: "label-text required"
                            }, "Tanggal Tindakan", -1)),
                            _createVNode(_unref(Field), { name: "ActionDate" }, {
                              default: _withCtx(({ handleChange }) => [
                                _createVNode(_unref(Calendar), {
                                  inputId: "actionDate",
                                  modelValue: _unref(values).ActionDate,
                                  "onUpdate:modelValue": [
                                    _cache[7] || (_cache[7] = ($event: any) => ((_unref(values).ActionDate) = $event)),
                                    handleChange
                                  ],
                                  minDate: _unref(values).AccidentDate,
                                  dateFormat: "dd/mm/yy",
                                  showTime: "",
                                  hourFormat: "24",
                                  placeholder: "DD/MM/YYYY HH:mm",
                                  disabled: !_unref(values).AccidentDate,
                                  class: "w-full",
                                  manualInput: false,
                                  inputClass: `${_unref(errors).ActionDate ? 'input-invalid' : ''}`
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "minDate", "disabled", "inputClass"])
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(errors).ActionDate), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("label", {
                            for: "location",
                            class: _normalizeClass(['label-text', { required: isRedCard.value }])
                          }, "Lokasi Kejadian", 2),
                          _createVNode(_unref(Field), {
                            id: "location",
                            name: "Location",
                            as: "input",
                            type: "text",
                            placeholder: "Masukkan Lokasi Kejadian",
                            class: _normalizeClass(`${_unref(errors).Location ? 'input-invalid' : ''}`),
                            modelValue: _unref(values).Location,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(values).Location) = $event)),
                            validateOnInput: true
                          }, null, 8, ["class", "modelValue"]),
                          _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(errors).Location), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("label", _hoisted_26, _toDisplayString(`${_unref(values).CardType?.name === 'Kartu Merah' ? 'Detail Kejadian' : 'Catatan Pelanggaran'}`), 1),
                      _createVNode(_unref(Field), {
                        id: "description",
                        name: "Description",
                        as: "textarea",
                        type: "text",
                        placeholder: "Ex. Jl. panjang blok Q",
                        class: _normalizeClass(`${_unref(errors).Description ? 'input-invalid' : ''}`),
                        modelValue: _unref(values).Description,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(values).Description) = $event)),
                        validateOnInput: true,
                        rows: "5"
                      }, null, 8, ["class", "modelValue"]),
                      _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(errors).Description), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _cache[30] || (_cache[30] = _createElementVNode("div", { class: "text-base font-semibold" }, "Foto Pendukung (Opsional)", -1)),
                  _cache[31] || (_cache[31] = _createElementVNode("div", { class: "text-sm text-grey-5" }, "Upload foto pendukung terkait pelanggaran karyawan", -1)),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      (!_unref(values).EvidenceImage && !tempImgProfile.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, _cache[27] || (_cache[27] = [
                            _createElementVNode("i", { class: "pi pi-image text-primary text-36px" }, null, -1),
                            _createElementVNode("div", { class: "text-sm text-grey-5" }, "Ukuran maksimal 2MB (JPG, PNG, JPEG)", -1)
                          ])))
                        : (_unref(values).EvidenceImage?.blob)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: _unref(values).EvidenceImage?.blob,
                              class: "wrap-img cursor-pointer",
                              style: {"width":"254px"},
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (openDetailImg(_unref(values).EvidenceImage.blob)))
                            }, null, 8, _hoisted_32))
                          : (tempImgProfile.value)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 2,
                                src: tempImgProfile.value,
                                class: "wrap-img cursor-pointer",
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (openDetailImg(tempImgProfile.value))),
                                style: {"width":"254px"}
                              }, null, 8, _hoisted_33))
                            : _createCommentVNode("", true),
                      _createVNode(ButtonFileUpload, {
                        inputId: "idPhotoProfile",
                        size: maxSizeFile,
                        onOnInputFile: _cache[12] || (_cache[12] = (newFile, oldFile) => onInputFile(newFile, 'photo-profile'))
                      }, {
                        default: _withCtx(() => [
                          (!_unref(values).EvidenceImage)
                            ? (_openBlock(), _createBlock(_unref(Button), {
                                key: 0,
                                class: "extra-submit-button p-small-btn flex gap-x-2",
                                style: {"border-color":"#04776D"},
                                outlined: true
                              }, {
                                default: _withCtx(() => _cache[28] || (_cache[28] = [
                                  _createElementVNode("i", { class: "pi pi-upload text-primary text-sm" }, null, -1),
                                  _createElementVNode("p", { class: "text-primary font-bold text-sm" }, _toDisplayString('Upload Foto'), -1)
                                ])),
                                _: 1,
                                __: [28]
                              }))
                            : _createCommentVNode("", true),
                          (_unref(values).EvidenceImage)
                            ? (_openBlock(), _createBlock(_unref(Button), {
                                key: 1,
                                class: "extra-submit-button p-small-btn flex gap-x-2 mt-3",
                                style: {"border-color":"#04776D"},
                                outlined: true
                              }, {
                                default: _withCtx(() => _cache[29] || (_cache[29] = [
                                  _createElementVNode("i", { class: "pi pi-upload text-primary text-sm" }, null, -1),
                                  _createElementVNode("p", { class: "text-primary font-bold text-sm" }, _toDisplayString('Ganti Foto'), -1)
                                ])),
                                _: 1,
                                __: [29]
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              (isShowViolenceHistory.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createVNode(EmployeeViolationHistory, { data: employeeDetail.value }, null, 8, ["data"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_unref(Button), {
                  class: "btn-back mr-2",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (onBack()))
                }, {
                  default: _withCtx(() => _cache[32] || (_cache[32] = [
                    _createTextVNode("Kembali")
                  ])),
                  _: 1,
                  __: [32]
                }),
                _createVNode(_unref(Button), {
                  type: "submit",
                  class: "btn-primary mr-1",
                  disabled: isSubmitInProgress.value
                }, {
                  default: _withCtx(() => _cache[33] || (_cache[33] = [
                    _createTextVNode("Simpan")
                  ])),
                  _: 1,
                  __: [33]
                }, 8, ["disabled"])
              ])
            ]),
            _: 1
          })
        ], 32))
      : _createCommentVNode("", true),
    _createVNode(HjpConfirmationModal, {
      show: attrModalConfirmation.show,
      title: attrModalConfirmation?.title,
      subTitle: attrModalConfirmation?.subTitle,
      btnSubmitTitle: attrModalConfirmation?.btnSubmitTitle,
      btnBackTitle: attrModalConfirmation?.btnBackTitle,
      subTitleHtml: attrModalConfirmation?.subTitleHtml,
      imgContent: attrModalConfirmation.imgContent,
      onHideDialog: hideDialogConfirmation,
      onOnSubmit: _cache[15] || (_cache[15] = ($event: any) => (toDetailPage()))
    }, null, 8, ["show", "title", "subTitle", "btnSubmitTitle", "btnBackTitle", "subTitleHtml", "imgContent"])
  ]))
}
}

})